document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap) return

  const { gsap } = window

  const section = document.querySelector('[data-legal-section]')
  if (!section) return

  const hero = section.querySelector('[data-legal-hero]')
  const heroLines = section.querySelectorAll('[data-legal-hero-line]')
  const content = section.querySelector('[data-legal-content]')
  const isDesktop = window.matchMedia('(min-width: 1200px)').matches
  const nav = isDesktop ? section.querySelector('[data-legal-nav-desktop]') : section.querySelector('[data-legal-nav-mobile]')
  const navLinks = nav ? [...nav.querySelectorAll('a')] : []

  if (hero) gsap.set(hero, { opacity: 0 })
  if (heroLines.length) gsap.set(heroLines, { yPercent: 120, opacity: 0 })
  if (navLinks.length) {
    gsap.set(navLinks, isDesktop ? { y: 16, opacity: 0 } : { x: 28, opacity: 0 })
    navLinks.forEach((link) => {
      link.classList.remove('opacity-0')
      link.style.transition = 'none'
    })
  }
  if (content) gsap.set(content, { y: 30, autoAlpha: 0 })

  const tl = gsap.timeline({ delay: 0.3 })

  if (hero) {
    tl.to(hero, {
      opacity: 1,
      duration: 0.9,
      ease: 'power3.out',
    })
  }

  if (heroLines.length) {
    tl.to(
      heroLines,
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.9,
        ease: 'power3.out',
        stagger: 0.12,
      },
      hero ? '<' : 0,
    )
  }

  if (navLinks.length) {
    tl.to(
      navLinks,
      {
        ...(isDesktop ? { y: 0 } : { x: 0 }),
        opacity: 1,
        duration: 0.8,
        ease: 'power3.out',
        stagger: 0.1,
        clearProps: 'opacity,transform',
        onComplete: () => {
          navLinks.forEach((link) => {
            link.style.transition = ''
          })
        },
      },
      '-=0.45',
    )
  }

  if (content) {
    tl.to(
      content,
      {
        y: 0,
        autoAlpha: 1,
        duration: 0.8,
        ease: 'power3.out',
        clearProps: 'visibility,transform',
      },
      navLinks.length ? '<' : '-=0.4',
    )
  }
})
